import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import SuperAdminCRMView from '@/views/super-admin/crm';

export const Route = createFileRoute('/_authenticated/super-admin-crm')({
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth;

    // Not authenticated → redirect to login
    if (!auth.accessToken || !auth.user) {
      throw redirect({ to: '/auth/login' });
    }

    // Not a superadmin → redirect to dashboard
    if (auth.user.role !== 'Super Admin' && auth.user.role_name !== 'Super Admin') {
      throw redirect({ to: '/dashboard' });
    }
  },

  component: SuperAdminCRMView,
});